<div class="content-wrapper">
  <div class="card card-nobody">
    <div class="card-body">
      <div class="card-wrapper">
        <div class="view-left">
          <h4>Ticket List</h4>
          <div class="pt-10px">
            <div style="margin-left: -10px">
              <ul class="accordion" id="accordion">
                <li *ngFor="let menu of ticketFilters; let i = index" [class.active]="menu.active"
                    [class.filter-selected]="selectedTicketFilter.name === menu.name" [class.is-sub]="!!menu.subItems"
                    class="menu-main">
                  <ng-container *ngIf="menu?.subItems; else single">
                    <div (click)="toggle(i)" class="menu">
                      {{ menu.name }}
                      <i class="fa-regular fa-chevron-down"></i>
                    </div>
                    <ul #subItems
                        [style.height.px]="menu.active ? subItems.scrollHeight : 0"
                        class="submenu">
                      <li (click)="selectTicketFilterRow(submenu)" *ngFor="let submenu of menu.subItems"
                          [class.filter-selected]="submenu._id === selectedTicketFilter?._id">
                        {{ submenu.name }}
                      </li>
                    </ul>
                  </ng-container>
                  <ng-template #single>
                    <div (click)="selectTicketFilterRow(menu)" class="menu">{{ menu.name }}</div>
                  </ng-template>

                </li>
              </ul>
            </div>
          </div>

          <div *ngIf="showFilter" class="v-line"></div>
          <div *ngIf="showFilter">
            <div class="d-flex justify-content-between">
              <h4>My List</h4>
              <div (click)="showFilterOpen(true, true)">
                <font-awesome [icon]="'fa-light fa-plus'" class="pointer"></font-awesome>
              </div>
            </div>
            <div class="pt-10px">
              <div style="margin-left: -10px">
                <ul class="accordion">
                  <li *ngFor="let menu of myFilters; let i = index" [class.active]="menu.active"
                      [class.filter-selected]="selectedTicketFilter._id === menu._id" [class.is-sub]="!!menu.subItems"
                      class="menu-main">
                    <ng-container *ngIf="menu?.subItems; else single">
                      <div (click)="toggle(i)" class="menu">
                        {{ menu.name }}
                        <i class="fa-regular fa-chevron-down"></i>
                      </div>
                      <ul #subItems
                          [style.height.px]="menu.active ? subItems.scrollHeight : 0"
                          class="submenu">
                        <li (click)="selectTicketFilterRow(submenu)" *ngFor="let submenu of menu.subItems"
                            [class.filter-selected]="submenu._id === selectedTicketFilter?._id">
                          {{ submenu.name }}
                        </li>
                      </ul>
                    </ng-container>
                    <ng-template #single>
                      <div (click)="selectTicketFilterRow(menu)" class="menu">{{ menu.name }}</div>
                    </ng-template>

                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div class="view-right">
          <div class="content-body">
            <app-dp-list (export)="exportResult()"
                         (handOverDate)="startDateChange($event)"
                         (openFilter)="showFilterOpen($event)"
                         (pageEvent)="onPageEvent($event)"
                         (payment)="goToPayment($event)"
                         (search)="search($event)"
                         [exportButton]=true
                         [openCalender]=this.openCalender
                         [pagedResponse]="pagedResponse"
                         [paymentButton]="isPayment"
                         [showFilter]="showFilter"
                         [showQ]=true>
              <table class="table table-list align-middle table-nowrap table-check">
                <thead>
                <tr>
                  <th>No.</th>
                  <th>Name</th>
                  <th *ngIf="companies.Sea === company" [attr.data-sort-fields]="'customerType'">Customer type</th>
                  <th>Store</th>
                  <th [attr.data-sort-fields]="'ticketNo'">TicketNo</th>
                  <th [attr.data-sort-fields]="'modelCode'">Model</th>
                  <th [attr.data-sort-fields]="'serialNo'">SerialNo{{ companies.SeaIm === company ? '/IMEI' : '' }}</th>
                  <th [attr.data-sort-fields]="'serviceType'">Type</th>
                  <th [attr.data-sort-fields]="'warrantyTerm'">Wty</th>
                  <th *ngIf="companies.Sea === company"
                      [attr.data-sort-fields]="'redo'">RRR
                  </th>
                  <th *ngIf="showTat" class="text-right">TAT</th>
                  <th [attr.data-sort-fields]="'address?.city'">City</th>
                  <th [attr.data-sort-fields]="'address?.state'">State</th>
                  <!--                  <th>Authorized<br/>Service<br/>Center</th>-->
                  <th [attr.data-sort-fields]="'postingDate'">PostDate</th>
                  <!--                  <th>Create</th>-->
                  <!--                  <th>Tat</th>-->
                  <th [attr.data-sort-fields]="'status'">Status</th>
                  <th *ngIf="companies.Sea === company">Cancel</th>
                </tr>
                </thead>
                <tbody>
                <tr (click)="selectDetailRow(ticket)"
                    *ngFor="let ticket of tickets; let i = index"
                    [class.active]="ticket === selectedTicket">
                  <td>{{ i + 1 }}</td>
                  <td>{{ ticket | displayName }}</td>
                  <td *ngIf="companies.Sea === company">{{ ticket.customerType }}</td>
                  <td>{{ ticket.dealerStore?.name }}</td>
                  <td>
                    <span [innerHTML]="ticket.ticketNo | ticketNo"></span>
                    {{ ticket.refTicketNo ? '/' : '' }}
                    <span *ngIf="ticket.refTicketNo" [innerHTML]="ticket.refTicketNo | ticketNo"></span>
                  </td>
                  <td><span class="model-text">{{ ticket.modelCode }}</span><img *ngIf="ticket.isDacorModel"
                                                                                 alt=""
                                                                                 class="ml-4px"
                                                                                 src="/assets/img/ico-dacor.svg"></td>
                  <td><span
                    class="model-text">{{ ticket.serialNo }}{{ companies.SeaIm === company ? '/' : '' }}{{ companies.SeaIm === company ? ticket.imei : '' }}</span>
                  </td>
                  <td>{{ ticket.serviceTypeName }}</td>
                  <td>{{ ticket.warrantyTerm }}</td>
                  <td *ngIf="companies.Sea === company">{{ ticket.redo ? 'R' : '' }}</td>
                  <td *ngIf="showTat" [ngClass]="getTatClass(ticket)">{{ calculateTat(ticket) }}</td>
                  <td>{{ ticket.address?.city }}</td>
                  <td>{{ ticket.address?.state }}</td>
                  <!--                  <td>{{ticket.ascNo}}-->
                  <!--                    <dp-badge [text]="ticket.ascNo" [color]="'#eedcdc'" [size]="'wd-xxs'"></dp-badge>-->
                  <!--                    <dp-badge [text]="ticket.ascNo" [color]="color.cardStatus" [size]="'wd-xxs'"></dp-badge>-->
                  <!--                  </td>-->
                  <td>{{ ticket.postingDate | hqDate }}</td>
                  <!--                  <td>{{ticket.auth.createdBy?.username}}</td>-->
                  <!--                  <td>{{ticket.createDate | tat: ticket.closeDate}}</td>-->
                  <td class="wd-100px">
                    <app-dp-progress (click)="eventService.statusClick($event, ticket?.processType, ticket.detailType, ticket.status)"
                                     [isFull]="false"
                                     [processType]="ticket?.processType"
                                     [status]="ticket?.ticketNo?.substring(0, 1) !== 'D' ? ticket?.status : ''"
                                     class="btn-cursor"></app-dp-progress>
                  </td>
                  <td *ngIf="companies.Sea === company">
                    <button (click)="cancelTicket($event, ticket)"
                            *ngIf="!['ST035', 'ST040', 'ST050','ST051', 'ST052'].includes(ticket.status)"
                            class="btn btn-dark button-small btn-cursor"
                            type="button">Cancel
                    </button>
                  </td>
                </tr>
                </tbody>
              </table>
            </app-dp-list>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

